var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle211(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "147.19080871285468 370.1868998109641 19.57345273304486 24.793100189035954",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M155.16,390.98c-3.51-3.84-4.39-8.01-3.8-12.51.47-3.57,4.24-5.32,7.42-3.64,1.77.93,2.92,2.43,3.6,4.28.65,1.76.56,3.65-.93,4.73-2.12,1.53-3.26,3.64-4.54,5.73-.27.44-.85.7-1.75,1.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle211);
export default __webpack_public_path__ + "static/media/twinkle-2-11.cffb33cee9b00db61e42b559d6781105.svg";
export { ForwardRef as ReactComponent };